var React = require('react');

function Plus (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"8BD69EEC-7592-4A45-8FA9-2F8BD7D904A8"),React.createElement("desc",{"key":1},"Created with sketchtool."),React.createElement("g",{"id":"Symbols","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":2},React.createElement("g",{"id":"01_Assets/Icon/UI/Plus","fill":"#FFFFFF"},React.createElement("path",{"d":"M19,17 L30,17 L30,19 L19,19 L19,30 L17,30 L17,19 L6,19 L6,17 L17,17 L17,6 L19,6 L19,17 Z","id":"Combined-Shape"})))]);
}

Plus.defaultProps = {"width":"36px","height":"36px","viewBox":"0 0 36 36","version":"1.1"};

module.exports = Plus;

Plus.default = Plus;
